import React from 'react';
import { FiCloud, FiShare2 } from 'react-icons/fi';
import MeinePlaene from './MeinePlaene';
import VeroeffentlichtePlaene from './VeroeffentlichtePlaene';

const PlanTabs = ({
  user,
  // Props für MeinePlaene
  plans,
  loading,
  error,
  refresh,
  expandedPlans,
  setExpandedPlans,
  planVersions,
  setPlanVersions,
  loadingVersions,
  setLoadingVersions,
  deleteDropdownOpen,
  setDeleteDropdownOpen,
  showEditButtons,
  onLoadFromDatabase,
  onUpdatePlan,
  handleDeletePlan,
  handleDeleteAllVersions,
  handleDeleteOlderVersions,
  loadPlanVersions,
  togglePlanExpansion,
  toggleDeleteDropdown,
  onCreateNewPlan,
  currentLoadedPlanId,
  // Props für VeroeffentlichtePlaene
  publishedPlans,
  loadingPublished,
  errorPublished,
  refreshPublished,
  expandedPublishedPlans,
  setExpandedPublishedPlans,
  publishedPlanVersions,
  setPublishedPlanVersions,
  loadingPublishedVersions,
  setLoadingPublishedVersions,
  loadPublishedPlanVersions,
  togglePublishedPlanExpansion
}) => {
  const [activeTab, setActiveTab] = React.useState('meine'); // 'meine' oder 'veroeffentlicht'

  if (!user) return null;

  return (
    <div style={{ 
      borderTop: '1px solid #ddd', 
      marginTop: '16px',
      backgroundColor: '#fafafa'
    }}>
      {/* Tab Header */}
      <div style={{
        display: 'flex',
        borderBottom: '1px solid #ddd',
        backgroundColor: '#f5f5f5'
      }}>
        <button
          onClick={() => setActiveTab('meine')}
          style={{
            flex: 1,
            padding: '12px 8px',
            border: 'none',
            backgroundColor: activeTab === 'meine' ? '#ffffff' : 'transparent',
            color: activeTab === 'meine' ? '#333' : '#666',
            borderBottom: activeTab === 'meine' ? '2px solid #4caf50' : 'none',
            cursor: 'pointer',
            fontSize: '14px',
            fontWeight: activeTab === 'meine' ? '600' : 'normal',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '6px',
            transition: 'all 0.2s ease'
          }}
          onMouseEnter={(e) => {
            if (activeTab !== 'meine') {
              e.target.style.backgroundColor = '#f0f0f0';
            }
          }}
          onMouseLeave={(e) => {
            if (activeTab !== 'meine') {
              e.target.style.backgroundColor = 'transparent';
            }
          }}
        >
          <FiCloud size={14} />
          Meine Pläne
          {plans && plans.length > 0 && (
            <span style={{
              backgroundColor: activeTab === 'meine' ? '#4caf50' : '#999',
              color: 'white',
              borderRadius: '10px',
              padding: '2px 6px',
              fontSize: '11px',
              minWidth: '18px',
              textAlign: 'center',
              lineHeight: '14px'
            }}>
              {plans.length}
            </span>
          )}
        </button>
        
        <button
          onClick={() => setActiveTab('veroeffentlicht')}
          style={{
            flex: 1,
            padding: '12px 8px',
            border: 'none',
            backgroundColor: activeTab === 'veroeffentlicht' ? '#ffffff' : 'transparent',
            color: activeTab === 'veroeffentlicht' ? '#333' : '#666',
            borderBottom: activeTab === 'veroeffentlicht' ? '2px solid #2196f3' : 'none',
            cursor: 'pointer',
            fontSize: '14px',
            fontWeight: activeTab === 'veroeffentlicht' ? '600' : 'normal',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '6px',
            transition: 'all 0.2s ease'
          }}
          onMouseEnter={(e) => {
            if (activeTab !== 'veroeffentlicht') {
              e.target.style.backgroundColor = '#f0f0f0';
            }
          }}
          onMouseLeave={(e) => {
            if (activeTab !== 'veroeffentlicht') {
              e.target.style.backgroundColor = 'transparent';
            }
          }}
        >
          <FiShare2 size={14} />
          Öffentlich
          {publishedPlans && publishedPlans.length > 0 && (
            <span style={{
              backgroundColor: activeTab === 'veroeffentlicht' ? '#2196f3' : '#999',
              color: 'white',
              borderRadius: '10px',
              padding: '2px 6px',
              fontSize: '11px',
              minWidth: '18px',
              textAlign: 'center',
              lineHeight: '14px'
            }}>
              {publishedPlans.length}
            </span>
          )}
        </button>
      </div>

      {/* Tab Content */}
      <div style={{ 
        backgroundColor: '#ffffff',
        minHeight: '300px',
        maxHeight: '500px',
        overflow: 'hidden'
      }}>
        {activeTab === 'meine' ? (
          <div style={{ padding: '0', margin: '0' }}>
            <MeinePlaene
              user={user}
              plans={plans}
              loading={loading}
              error={error}
              refresh={refresh}
              expandedPlans={expandedPlans}
              setExpandedPlans={setExpandedPlans}
              planVersions={planVersions}
              setPlanVersions={setPlanVersions}
              loadingVersions={loadingVersions}
              setLoadingVersions={setLoadingVersions}
              deleteDropdownOpen={deleteDropdownOpen}
              setDeleteDropdownOpen={setDeleteDropdownOpen}
              showEditButtons={showEditButtons}
              onLoadFromDatabase={onLoadFromDatabase}
              onUpdatePlan={onUpdatePlan}
              handleDeletePlan={handleDeletePlan}
              handleDeleteAllVersions={handleDeleteAllVersions}
              handleDeleteOlderVersions={handleDeleteOlderVersions}
              loadPlanVersions={loadPlanVersions}
              togglePlanExpansion={togglePlanExpansion}
              toggleDeleteDropdown={toggleDeleteDropdown}
              onCreateNewPlan={onCreateNewPlan}
              currentLoadedPlanId={currentLoadedPlanId}
              isInTab={true} // Neue Prop um der Komponente zu sagen, dass sie in einem Tab ist
            />
          </div>
        ) : (
          <div style={{ padding: '0', margin: '0' }}>
            <VeroeffentlichtePlaene
              user={user}
              publishedPlans={publishedPlans}
              loading={loadingPublished}
              error={errorPublished}
              refresh={refreshPublished}
              expandedPlans={expandedPublishedPlans}
              setExpandedPlans={setExpandedPublishedPlans}
              planVersions={publishedPlanVersions}
              setPlanVersions={setPublishedPlanVersions}
              loadingVersions={loadingPublishedVersions}
              setLoadingVersions={setLoadingPublishedVersions}
              onLoadFromDatabase={(planId, isPublished) => {
                if (isPublished) {
                  onLoadFromDatabase(planId, true);
                } else {
                  onLoadFromDatabase(planId);
                }
              }}
              loadPlanVersions={loadPublishedPlanVersions}
              togglePlanExpansion={togglePublishedPlanExpansion}
              currentLoadedPlanId={currentLoadedPlanId}
              isInTab={true} // Neue Prop um der Komponente zu sagen, dass sie in einem Tab ist
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default PlanTabs;